function Accordions() {
	this.init();
}

Accordions.prototype.init = function () {
	var self = this;
	$('.accordion li .accordion-content').each(function() {
		$(this).accordion($(this).parent());
	});
	$('.filter-category__dropdown').accordion('.filter-category__header');
	$('.filter-tags__dropdown').accordion('.filter-tags__header');
};

jQuery.fn.accordion = function(parent) {
	var self = $(this);
	self.parent = $(parent);
	self.data('accordion', self);
	self.parent.find('> a').on('click keydown', function(e) {
		if(!e.key || e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
			e.preventDefault();
			toggleWithAriaExpanded(this);
		}
	});

	$(document).on('keydown', function(e) {
		if(self.hasClass('-active') && e.key === "Escape") {
			toggleWithAriaExpanded('.accordion-navigation > a');
		}
	});

	function toggleWithAriaExpanded(target) {
		var expanded = $(target).attr('aria-expanded') == 'false' ? 'true' : 'false';
		$(target).attr('aria-expanded', expanded);
		self.toggle();
	}

	self.toggle = function() {
		var self = this;
		if (!self.hasClass('-active')) {
			if (self.closest('.dropdown-group').find('.dropdown.-active').length) {
				self.closest('.dropdown-group').find('.dropdown.-active').each(function() {
					$(this).data('accordion').collapse();
				});
				clearTimeout(self.t2);
				clearTimeout(self.t4);
				clearTimeout(self.t5);
				self.t5 = setTimeout(function() {
					self.open();
				},400);
			} else {
				self.open();
			}
		} else {
			self.collapse();
		}
	};

	self.open = function() {
		var self = this;
		var outerHeight = self.outerHeight();
		cancelAnimationFrame(app.affixAnimationID);
		clearTimeout(self.t2);
		clearTimeout(self.t4);
		clearTimeout(self.t5);
		self.parent.addClass('-active');
		if (self.hasClass('-animating')) {
			self.css({height:outerHeight});
		} else {
			self.addClass('-active');
			outerHeight = self.outerHeight();
			self.css({height:0});
			self.t1 = setTimeout(function() {
				self.addClass('-animating');
				self.css({height:outerHeight});
			},10);
		}
		self.t2 = setTimeout(function() {
			clearTimeout(self.t2);
			self.attr('style','').removeClass('-animating');
			console.log(self.a2);
			cancelAnimationFrame(app.affixAnimationID);
		},500);
		app.affixAnimationID = requestAnimationFrame(app.animateAffix);
	};

	self.collapse = function() {
		var self = this;
		var outerHeight = self.outerHeight();
		cancelAnimationFrame(app.affixAnimationID);
		clearTimeout(self.t2);
		clearTimeout(self.t4);
		clearTimeout(self.t5);
		self.parent.removeClass('-active');
		if (self.hasClass('-animating')) {
			self.css({height:0});
		} else {
			self.css({height:outerHeight});
			self.t3 = setTimeout(function() {
				self.addClass('-animating');
				self.css({height:0});
			},10);
		}
		self.t4 = setTimeout(function() {
			clearTimeout(self.t4);
			self.attr('style','').removeClass('-active').removeClass('-animating');
			cancelAnimationFrame(app.affixAnimationID);
		},500);
		app.affixAnimationID = requestAnimationFrame(app.animateAffix);
	};
};